export const apiRoutes = {
    flightTrips: {
        getFlightTrips: '/flight-trips/getDeviceFlightData',
        getFlightTripsByIp: '/flight-trips/getDeviceFlightDataByIp',   // ← new
    },
    flightRemovalOffsets: {
        getForDevice: '/flight-removal-offsets/getForDevice',
        getForDeviceByIp: '/flight-removal-offsets/getForDeviceByIp', // ← new
    },
    rules: {
        getAllRules: '/rules/getAllRules',
    },
    dcmm: {
        getDeviceDetails: 'devices/getDeviceDetails',
        getDeviceDetailsByIp: 'devices/getDeviceDetailsByIp',
        getById: 'devices/getById',
        updateLocation: 'devices/updateLocation'
    },
    templates: {
        getById: "templates/getById"
    }
};
